// @flow
import * as React from 'react';
import classnames from 'classnames';
import './RadarText.scss';

type RadarTextType =
  | 'attribute'
  | 'metadata'
  | 'numeric'
  | 'string'
  | 'red'
  | 'amber'
  | 'green';

const radarTextTypes = [
  'attribute',
  'metadata',
  'numeric',
  'string',
  'red',
  'amber',
  'green',
];

type RadarTextProps = {|
  children: React.Node,
  type: RadarTextType,
|};

export const RadarText = ({children, type}: RadarTextProps) => {
  // If the specified type is invalid, default to 'attribute'.
  const actualType = radarTextTypes.includes(type) ? type : 'attribute';
  return (
    <span className={classnames('RadarText', `RadarText--${actualType}`)}>
      {children}
    </span>
  );
};
